import React, { RefObject } from "react";
import { Link } from 'react-router-dom';
import { Menu, Container, Sidebar, Icon, Divider, Sticky, Ref } from "semantic-ui-react";
import HeaderMobile from "./HeaderMobile";
import Routes from "./Routes";

export type PrincipaleState = {
    visible: boolean
}

export default class Principale extends React.Component<{}, PrincipaleState> {
    private contextRef: RefObject<HTMLInputElement>;

    constructor(props: {}) {
        super(props);

        this.contextRef = React.createRef();

        this.state = { visible: false };
    }

    render() {
        // il div è utilizzato perche il container fluid, in versione mobile, lascia dello spazio a destra e sinistra nel menu
        const { visible } = this.state;
        return (
            <div>
                <Sticky context={this.contextRef}>
                    <HeaderMobile onMenuClick={this.showSidebar} />
                </Sticky>
                <Sidebar.Pushable >
                    <Sidebar as={Menu} animation='overlay' icon='labeled' inverted vertical visible={visible} width='thin'
                             onHide={this.handleSidebarHide}>
                        <Menu.Item as={Link} to='/archiviazione' onClick={this.handleSidebarHide}>
                            <Icon name='file alternate' inverted />
                            Archiviazione
                        </Menu.Item>
                        <Menu.Item as={Link} to='/contributi' onClick={this.handleSidebarHide}>
                            <Icon name='calendar check' inverted />
                            Contributi
                        </Menu.Item>
                    </Sidebar>
                    <Sidebar.Pusher>
                        <Container fluid>
                            <Divider hidden />
                            <Ref innerRef={this.contextRef}>
                                <Routes />
                            </Ref>
                        </Container>
                    </Sidebar.Pusher>
                </Sidebar.Pushable>
            </div>
        );
    }
    
    showSidebar = () => this.setState({ visible: true });
    
    handleSidebarHide = () => this.setState({ visible: false });
}
